import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { env } from '@noor/config';
import { storefrontSearchSchema, type StorefrontSearch } from '@/entities/storefront';
import { StorefrontPage } from '@/pages/storefront';
export const Route = createFileRoute('/storefront/categories')({
  staticData: { permission: 'storefront.categories.view' },
  beforeLoad: () => {
    if (!env.VITE_ENABLE_MSW && !readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  validateSearch: storefrontSearchSchema,
  component: StorefrontRoute,
});
function StorefrontRoute() {
  const params = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onParamsChange = (next: Partial<StorefrontSearch>) => {
    void navigate({
      search: (previous) => ({
        ...previous,
        ...next,
        ...(!('page' in next) ? { page: 1 } : {}),
      }),
    });
  };
  return (
    <StorefrontPage entity="categories" params={params} onParamsChange={onParamsChange} />
  );
}
